import CControl from "./CControl";
import { IComboBoxOption } from "@fluentui/react";
import { CForm } from "./JSForm";
import { JSDataSource } from "./JSDataSource";
import { IDictionary } from "@ioip/core/lib";
import { IFieldSchema } from "./IFieldSchema";

export interface ICComboBoxProps {
    form: CForm;
    dataSource: JSDataSource;
    schema: IFieldSchema;
}

class CComboBox extends CControl {

    #props: ICComboBoxProps;

    constructor(props: ICComboBoxProps) {
        super({ form: props.form, schema: props.schema });
        this.#props = props;
    }

    get label(): string {
        return this.#props.schema.label;
    }

    get datasource(): JSDataSource {
        return this.#props.dataSource;
    }

    get items(): IDictionary<any> {
        return this.#props.dataSource?.items || [];
    }

    get selectedText(): any {
        const value: any = this.value;
        return this.#props.dataSource?.getText(value);
    }

    asFluentUI(): IComboBoxOption[] {
        const dataSource = this.#props.dataSource;
        if (dataSource == null)
            return [];
        const keyBinding = dataSource.keyBinding;
        const textBinding = dataSource.textBinding;
        return dataSource.items.select(o => ({ key: o[ keyBinding ]?.value, text: o[ textBinding ]?.value || '' })).toArray();
    }

    validate(): boolean {
        this.errorMessage = null;
        if (this.required) {
            if (this.value == null || this.value == 0) {
                this.errorMessage = 'Campo requerido';
                return false;
            }
        }
        return true;
    }

}

export default CComboBox;